import { Eye, Cog, WifiOff, Calculator, Shield } from "lucide-react";

export default function DifferentialsSection() {
  const differentials = [
    {
      icon: Eye,
      title: "Clareza estrutural diária",
      description: "Você não espera o problema aparecer.",
    },
    {
      icon: Cog,
      title: "Inteligência aplicada à realidade",
      description: "Sem complexidade corporativa.",
    },
    {
      icon: WifiOff,
      title: "Executável offline",
      description: "Seus dados permanecem na sua empresa.",
    },
    {
      icon: Calculator,
      title: "Decisão baseada em matemática",
      description: "A estrutura fala. Você escuta.",
    },
    {
      icon: Shield,
      title: "Tecnologia 100% offline",
      description: "Todos os dados permanecem exclusivamente dentro da sua empresa.",
    },
  ];

  return (
    <section
      id="differentials"
      className="relative py-16 md:py-32 bg-[#0F1115]"
      data-testid="differentials-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Por que KpAction
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Diferenciais <span className="text-[#F59E0B]">Estratégicos</span>
          </h2>
        </div>

        {/* Differentials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-16">
          {differentials.map((diff, index) => (
            <div
              key={index}
              className="relative bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 hover:border-[#F59E0B]/50 transition-all group"
              data-testid={`differential-${index}`}
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-[#0E3A46] rounded-sm group-hover:bg-[#F59E0B]/10 transition-colors">
                  <diff.icon className="h-6 w-6 text-[#F59E0B]" />
                </div>
                <div>
                  <h3 className="font-heading text-xl font-bold text-[#E5E7EB] mb-2">
                    {diff.title}
                  </h3>
                  <p className="text-[#9CA3AF]">{diff.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Positioning Statement */}
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10">
            <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#6B7280] bg-[#0F1115] border border-[#2A2F38] rounded-sm mb-6">
              Posicionamento
            </span>

            <p className="text-[#9CA3AF] text-sm md:text-base leading-relaxed mb-6">
              Decisões operacionais tornam-se mais consistentes quando deixam de depender apenas de percepção e passam a considerar a dinâmica real do sistema produtivo.
            </p>

            <div className="w-16 h-px bg-[#2A2F38] mx-auto my-6" />

            <p className="text-[#9CA3AF] text-base md:text-lg mb-4">
              Empresas que sobrevivem fazem o necessário.
            </p>
            <p className="text-[#E5E7EB] text-base md:text-lg font-medium mb-6">
              Empresas que crescem sustentavelmente estruturam suas decisões.
            </p>

            <div className="w-16 h-px bg-[#2A2F38] mx-auto my-6" />

            <p className="text-[#9CA3AF] mb-2">
              O KpAction não é sobre controle excessivo.
            </p>
            <p className="text-[#F59E0B] text-lg font-medium">
              É sobre previsibilidade inteligente.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
